import React, { memo } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import CategoryTag from '@atlassian/jira-business-categories/src/ui/category-form/category-tag/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import type { ListViewControllerData } from '../../../../controllers/list-view-issues/types.tsx';
import messages from './messages.tsx';

export const CategoryItem = memo<{
	data: ListViewControllerData;
}>(({ data }: { data: ListViewControllerData }) => {
	const { formatMessage } = useIntl();

	return data.category?.name != null ? (
		<CategoryTag
			categoryColor={data.category.color}
			categoryName={data.category.name}
			isInteractive={false}
		/>
	) : (
		<UncategorizedLabel>{formatMessage(messages.noCategory)}</UncategorizedLabel>
	);
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const UncategorizedLabel = styled.span({
	color: token('color.text'),
});
